import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  // Koyu tema iptal edildi - her zaman açık tema kullan
  const [theme] = useState('light');

  useEffect(() => {
    const root = window.document.documentElement;
    
    // Her zaman dark class'ını kaldır (koyu tema devre dışı)
    root.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  }, []);

  const toggleTheme = () => {
    // Fonksiyon artık bir şey yapmıyor (koyu tema devre dışı)
  };

  const setTheme = () => {
    // Fonksiyon artık bir şey yapmıyor (koyu tema devre dışı)
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
